// src/components/input/index.tsx
import React from "react";
import { input } from "@pinatagrams/design-system/recipes";
import { motion } from "motion/react";
import { jsx } from "react/jsx-runtime";
var TextInput = React.forwardRef(({ size, emphasis, ...props }, ref) => {
  const className = input({ size, emphasis });
  return /* @__PURE__ */ jsx(motion.input, { ref, className, ...props });
});
TextInput.displayName = "TextInput";
var input_default = TextInput;
export {
  TextInput,
  input_default as default
};
//# sourceMappingURL=input.js.map